import { GridCellParams } from "@mui/x-data-grid";
import { UseRecordsOptions } from "../../api/useRecords";
import { RecordContextType } from "../../components/record/Record";
import { treatmentsSearchSettings, leadsSearchSettings } from "../../utils/createSearchFilter";

export const psyEvaluationsOptions = {
	fieldsToRemove: {
		fieldTypesToRemove: ["alias"],
		fieldNamesToRemove: ["password"],
	},
	groupsOptions: {
		fieldsWithExtraOptions: [
			{
				field: "treatment",
				disabled: true,
			},
			{
				field: "lead",
				disabled: true,
			},
			{
				field: "instrument_id",
				disabled: true,
			},
		],
	},
	dataGridOptions: {
		fieldsToSearch: [
			{
				field: "instrument_id",
				displayTemplate: "{{instrument_id.name}}",
			},
		],
		extraColumns: {
			beggining: [
				{
					field: "treatment_or_lead",
					headerName: "Tratamento / Lead",
					width: 150,
					renderCell: (params: GridCellParams) => {
						const treatment = params.row?.treatment;
						if (treatment?.client) {
							return treatment.client.client_id;
						}
						const lead = params.row?.lead;
						if (lead) {
							return lead.name || lead.id;
						}
						return null;
					},
				},
			],
		},
	},
	createRelatedParams: (params: RecordContextType | undefined) => createPsyEvaluationParams(params),
} as UseRecordsOptions;

export const psyEvaluationsCreateGroupsOptions = {
	fieldsWithExtraOptions: [
		{ field: "instrument_id", enabled: true },
		{ field: "status", allowedChoices: ["completed"] },
		{ field: "treatment", createFilter: (params: any) => treatmentsSearchSettings(params), displayTemplate: "{{client.client_id}} - {{client.user_id.first_name}} {{client.user_id.last_name}}" },
		{ field: "lead", createFilter: (params: any) => leadsSearchSettings(params), displayTemplate: "{{first_name}} {{last_name}} - {{email}}" },
		{ field: "password", hidden: { create: true } },
		{ field: "age_at_response", hidden: { create: true } },
		{ field: "completed_at", hidden: { create: true } },
		{ field: "sent_at", hidden: { create: true } },
		{ field: "started_at", hidden: { create: true } },
		{ field: "responses_scores", hidden: { create: true } },
		{ field: "response_answers", hidden: { create: true } },
		{ field: "scores", hidden: { create: true } },
	],
};

export const responseAnswersExtraColumns = {
	beggining: [
		{
			field: "number",
			headerName: "Nº",
			width: 50,
			renderCell: (params: GridCellParams) => {
				return params.row?.instrument_item?.number ?? null;
			},
		},
	],
	end: [
		{
			field: "dimension",
			headerName: "Dimensão",
			width: 150,
			renderCell: (params: GridCellParams) => {
				const junctionRows = params.row?.instrument_item?.instrument_dimensions ?? [];
				const dimensionNames = junctionRows
					.map((junctionRow: any) => junctionRow.instrument_dimensions_id?.name)
					.filter(Boolean);
				return dimensionNames.length > 0 ? dimensionNames.join(", ") : null;
			},
		},
		{
			field: "cutoff",
			headerName: "Cutoff",
			width: 120,
			renderCell: (params: GridCellParams) => {
				const metadata = params.row?.instrument_item?.metadata;
				if (!metadata?.cutoff) return null;
				return metadata.cutoff;
			},
		},
	],
};

const createPsyEvaluationParams = async (recordContext: RecordContextType | undefined) => {
	if (!recordContext?.item) return;
	if (recordContext.entity === "treatments")
		return `[treatments][id][*,client.*,client.user_id.*]=${recordContext.item.id}`;
	if (recordContext.entity === "leads")
		return `[leads][id]=${recordContext.item.id}`;
};
